export default {
  RETAIL: 'retail',
  STOCK: 'stock',
  CONTAINER: 'container'
}
